import * as React from 'react';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Prompt } from 'react-router';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { formValueSelector, reduxForm } from 'redux-form';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { DefaultField } from '@components/form';
import { createEventRecord, syncEventRecord } from './_eventsActions';
import { spsFields } from './_eventsEnums';
import { setMds } from '@utils/utils';
import { Loader } from '@components/loader';

const enhance = compose<any, any>(
  connect<any, any, any>(state => ({
    files: formValueSelector('module-events')(state, 'files')
  })),
  withProps(({ eventId }) => ({
    initialValues: { eventId },
    urls: {
      recordCase: 'api/common/sps/record/rcase',
      documentMark: 'api/common/sps/document/marks',
      documentCase: 'api/common/sps/document/dcase',
      documentSymbol: 'api/common/sps/document/symbols'
    }
  })),
  withState('loader', 'setLoader', false),
  withHandlers({
    onSubmit: ({ alreadyExist, closeItem, reloadEvent, setLoader }) => async formData => {
      setLoader(true);
      const { fileId, recordCase, ...syncData } = formData;
      const response = alreadyExist
        ? await syncEventRecord({ ...syncData, fileId })
        : await createEventRecord(formData);

      if (response) {
        await reloadEvent();
        setLoader(false);
        closeItem();
      } else {
        setLoader(false);
      }
    }
  }),
  reduxForm({ form: 'module-events-record' })
);

const View: React.SFC<any> = ({
  alreadyExist,
  dirty,
  submitSucceeded,
  submitting,
  files,
  urls,
  sps,
  loader,
  ...props
}) => {
  const itemsList = { fileId: files };

  const fields: Array<any> = get(spsFields, sps, []).filter(({ firstOnly }) => !firstOnly || !alreadyExist);
  const mds = setMds(fields.length);
  return (
    <div>
      {loader && <Loader />}
      <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
      <form className="layout" onSubmit={props.handleSubmit}>
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <h4>Synchronizovat dokumenty</h4>
            </Col>
          </Row>
          <Row>
            {get(spsFields, sps, [])
              .filter(({ firstOnly }) => !firstOnly || !alreadyExist)
              .map(({ firstOnly, md, name, items = '', ...f }, index) => (
                <Col md={mds[index]} key={name}>
                  <DefaultField name={name} items={itemsList[items]} {...f} />
                </Col>
              ))}
          </Row>
          <Button type="submit" label="Synchronizovat" primary={true} style={{ margin: '16px 0 16px 16px' }} />
          <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
        </Grid>
      </form>
    </div>
  );
};

export const EventsFormFilesRecordModal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormFilesRecordModal.tsx